/*
  Reveal cards inside horizontal "swipe on mobile" carousels.

  Cards carry the theme's `.animation` class, which starts them at opacity 0 and
  relies on app.min.js to fade them in once they pass the `:in-viewport` filter.
  That filter also tests the horizontal axis (`left >= viewportWidth` fails), and
  the only thing that re-runs it is a *window* scroll. Cards parked off-screen to
  the right of a carousel therefore never animate in, so every slide past the
  first one or two stays invisible no matter how far the user swipes.

  Re-running the theme's own check whenever a carousel scrolls fixes that, and
  keeps the intended fade-in for each card as it swipes into view.
*/
(function () {
  var SCROLLERS =
    '.blog-posts.swipe-on-mobile .row,' +
    '.multicolumn.swipe-on-mobile .row,' +
    '.text-with-icons.swipe-on-mobile .text-with-icons__inner';

  function revealDirectly(scroller) {
    var cards = scroller.querySelectorAll('.animation');

    for (var i = 0; i < cards.length; i++) {
      cards[i].style.opacity = '1';
      cards[i].style.visibility = 'visible';
      cards[i].style.transform = 'none';
    }
  }

  function refresh(scroller) {
    if (window.jQuery) {
      // Fires only app.min.js' animation handler, which re-tests every
      // `.animation` element against the (now scrolled) viewport.
      window.jQuery(window).trigger('scroll.thb-animation');
    } else {
      revealDirectly(scroller);
    }
  }

  function watch(scroller) {
    if (scroller.dataset.swipeAnimationBound === 'true') return;
    scroller.dataset.swipeAnimationBound = 'true';

    var queued = false;

    scroller.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;

        requestAnimationFrame(function () {
          queued = false;
          refresh(scroller);
        });
      },
      { passive: true }
    );
  }

  function init(root) {
    var scrollers = (root || document).querySelectorAll(SCROLLERS);

    for (var i = 0; i < scrollers.length; i++) {
      watch(scrollers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Sections re-render in the theme editor without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
